import React, { useEffect, useState, useRef } from "react";
import next_btn from "../../assets/img/next_btn.png";
import call_btn from "../../assets/img/call_btn.png";
import founderimg from '../../assets/img/founder.webp';
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearData, upcommingUserList } from "../../store/apiSlice/UpcommingSlice";
import { Chat, Send } from "@mui/icons-material";
import { Button, Modal } from "react-bootstrap";
import { clearChat, getChatHistory } from "../../store/apiSlice/ChatSlice";
import { uploadFile } from "../../store/apiSlice/uploadFileSlice";
import moment from "moment";
import nannyicon from "../../assets/img/nany_icon.png";
import socket from "../../utils/socket";
import { containsContactInfo } from "../../utils/help";
import { ClipLoader } from "react-spinners";
const STATUS_LABELS = {
  0: "Pending",
  1: "Accepted",
  2: "On The Way",
  3: "Reached",
  4: "Completed",
  5: "Cancelled",
  6: "Rejected",
};


const UpcomingUser = () => {
  const msgEndRef = useRef(null);
  const dispatch = useDispatch();

  const upcommingData = useSelector((state) => state.rootReducer.upcommingReducer.data);
  const profileData = useSelector((state) => state.rootReducer.UserProfileReducer.data);
  const chatData = useSelector((state) => state.rootReducer.chatHistoryReducer.data);
  const uploadFileData = useSelector((state) => state.rootReducer.uploadFileReducer.data);

  const userId = localStorage.getItem("userId");
  const type = localStorage.getItem("type");
  const currentDate = new Date();
  const formattedDate = currentDate.toISOString();

  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [dataList, setDataList] = useState(null);
  const [chatIndex, setChatIndex] = useState(null);
  const [myChatData, setChatData] = useState([]);
  const [show, setShow] = useState(false);

  const [attachment, setAttachment] = useState(null);
  const [uploading, setUploading] = useState(false);

  // === FETCH UPCOMING BOOKINGS ===
  useEffect(() => {
    dispatch(clearData());
    setChatIndex(null);
    setShow(false);
    dispatch(upcommingUserList(0)).finally(() => setLoading(false));
  }, [dispatch]);

  useEffect(() => {
    if (upcommingData && upcommingData.status === 1) {
      // setDataList(upcommingData.data.data);
      const filteredData = upcommingData.data.data.filter(
        item => !(item.isActive === 0 && (item.type === 0 || item.type === 1 || item.type === 2))
      );

      setDataList(filteredData);
    }
  }, [upcommingData]);

  // === CHAT DATA ===
  useEffect(() => {
    if (chatData && chatData.status === 1) {
      setShow(true);
      setChatData(chatData.data);
    }
  }, [chatData]);

  // === SOCKET ===
  useEffect(() => {
    if (!socket.connected) {
      socket.connect();
      socket.emit("touch_server", { userId });
    }

    socket.on("booking_status_changed", () => {
      dispatch(upcommingUserList(0));
    });

    socket.on("receive_message", (data) => {
      setChatData((prev) => [...prev, data]);
    });

    return () => {
      socket.off("booking_status_changed");
      socket.off("receive_message");
      clearChat();
    };
  }, [dispatch, userId]);

  useEffect(() => {
    if (show) scrollToBottom();
  }, [myChatData, show]);

  // === FILE HANDLERS ===
  const previewFile = (file) => {
    const type = file.type;
    const name = file.name;
    const localUrl = URL.createObjectURL(file);
    return { type, name, localUrl };
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setAttachment(previewFile(file));
    setUploading(true);
    dispatch(uploadFile(file));
  };

  const discardAttachment = () => {
    setAttachment(null);
    setUploading(false);
  };

  useEffect(() => {
    if (!attachment) return;
    if (uploadFileData && uploading) {
      setAttachment((prev) => ({
        ...prev,
        url: uploadFileData.Location,
        uploaded: true,
      }));
      setUploading(false);
    }
  }, [uploadFileData, uploading, attachment]);

  // === SEND MESSAGE ===
  const sendMessage = () => {
    if (!message.trim() && !attachment?.uploaded) return;

    if (containsContactInfo(message)) {
      alert("Sharing contact information is not allowed.");
      return;
    }

    const booking = dataList[chatIndex];
    const msgData = {
      bookingId: booking._id,
      userId,
      otherUserId: type === "1" ? booking.nannyId._id : booking.userId._id,
      message: message || "",
      attachment: attachment?.uploaded ? attachment.url : null,
      attachmentType: attachment?.uploaded ? attachment.type : null,
      createdAt: formattedDate,
    };

    setChatData((prev) => [...prev, { ...msgData, senderId: { _id: userId } }]);
    socket.emit("send_message", msgData);

    setMessage("");
    setAttachment(null);
  };

  // === CHAT FUNCTIONS ===
  const getChat = (id) => {
    dispatch(getChatHistory({ skip: 0, limit: 100, id }));
  };

  const openChat = (id, index) => {
    getChat(id);
    setChatIndex(index);
  };

  const scrollToBottom = () => {
    msgEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const getFormattedDateTime = (dateString) => {
    const now = moment();
    const messageTime = moment.utc(dateString).local();

    if (now.isSame(messageTime, "day")) return messageTime.format("hh:mm A");
    if (now.subtract(1, "day").isSame(messageTime, "day")) return "Yesterday";
    if (now.isSame(messageTime, "year")) return messageTime.format("D MMM hh:mm A");
    return messageTime.format("D MMM YYYY");
  };

  return (
    <>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <div className="row all_order_box">
            {dataList && dataList.length > 0 ? (
              dataList.map((item, index) => (
                <div key={index} className="col-md-6">
                  <div className="card nany_orders my-2">
                    <div className="card.body d-flex">
                      <div className="card.img mr-2">
                        <img
                          alt="card"
                          src={item.nannyId.profileImage}
                          className="rounded-circle"
                        />
                      </div>
                      <div>
                        <div className="card-title">
                          <h6>
                            {item.nannyId.firstName} {item.nannyId.lastName}
                          </h6>
                          <p className="text-sm-end text-md-start text-lg-end">
                            ${item.price}
                          </p>
                        </div>

                        <div className="Card.Text">
                          <div className="nanny-info">
                            <div className="location mb-1 d-flex align-items-baseline">
                              <i className="fa fa-location me-1"></i>
                              <span>{item.address}</span>
                            </div>
                            <p className="time mb-0 text-truncate">
                              {item.date} <span>{item.time}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {item && item.isActive === 1 ? <div className="upcoming_option mt-2 pt-2">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          {/* <Link to="#" className="mb-0">
                            {item.status === 0
                              ? "Request Pending"
                              : item.status === 1
                                ? "Request Accepted"
                                : "On The Way"}
                          </Link> */}

                          <span
                            className={`status-badge status-${item.status ?? 0}`}
                          >
                            {item.status === 0
                              ? "Request Pending"
                              : item.status === 1
                                ? "Request Accepted"
                                : "On The Way"}
                          </span>
                        </div>
                        <div>
                          <div className="upcoming_btns d-flex align-items-center">
                            <Button
                              type="button"
                              className="map_btn"
                              onClick={() => {
                                if (item.latitude && item.longitude) {
                                  const url = `https://www.google.com/maps?q=${item.latitude},${item.longitude} (${item.address})`;
                                  window.open(url, "_blank");
                                } else alert("Location not available");
                              }}
                            >
                              <img src={next_btn} alt="logo" />
                            </Button>
                            <Button
                              type="button"
                              onClick={() => openChat(item._id, index)}
                              className="map_btn"
                            >
                              <Chat />
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div> :
                      <div className='ordered_persons'>
                        <div className="nanny-small-info mt-2">
                          <div className="d-flex justify-content-between align-items-center">

                            <div className="d-flex align-items-center">
                              <img
                                src={founderimg}
                                alt="nanny"
                                className="rounded-circle me-2"
                                width={40}
                                height={40}
                              />
                              <h4 className="mb-0">{item.categoryId?.name}</h4>
                            </div>

                            {/* RIGHT: STATUS */}
                            <span
                              className={`status-badge status-${item.status ?? 0}`}
                            >
                              {STATUS_LABELS[item.status] || "Pending"}
                            </span>

                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              ))
            ) : (
              <p style={{ fontWeight: 600 }}>No Bookings Found</p>
            )}
          </div>

          {/* CHAT MODAL */}
          {show && chatIndex !== null && (
            <Modal
              show={show}
              onHide={() => setShow(false)}
              size="lg"
              centered
              className="modal_address change_time chat_modal"
            >
              <Modal.Header closeButton className="p-2">
                <Modal.Title className="chat_heading">
                  <img src={nannyicon} alt="icon" />
                </Modal.Title>
              </Modal.Header>

              <Modal.Body
                style={{
                  padding: 0,
                  display: "flex",
                  flexDirection: "column",
                  height: "70vh",
                  backgroundColor: "#f9f9f9",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              >
                {/* Messages */}
                <ul
                  style={{
                    listStyle: "none",
                    margin: 0,
                    padding: "1rem",
                    flex: 1,
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                  }}
                >
                  {myChatData.map((item, idx) => {
                    const isSender = item.senderId._id === userId;
                    return (
                      <li
                        key={idx}
                        style={{
                          alignSelf: isSender ? "flex-end" : "flex-start",
                          maxWidth: "75%",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: isSender ? "#89d6ce" : "#e5e5ea",
                            color: isSender ? "#fff" : "#000",
                            borderRadius: "20px",
                            padding: "10px 14px",
                            wordBreak: "break-word",
                            fontSize: "14px",
                            lineHeight: "1.4",
                          }}
                        >
                          {item.message}
                          {item.attachment && (
                            <div style={{ marginTop: "8px" }}>
                              {item.attachmentType?.startsWith("image/") && (
                                <img
                                  src={item.attachment}
                                  alt="attachment"
                                  style={{ maxWidth: "200px", borderRadius: "10px" }}
                                />
                              )}
                              {item.attachmentType?.startsWith("video/") && (
                                <video
                                  controls
                                  src={item.attachment}
                                  style={{ maxWidth: "250px", borderRadius: "10px" }}
                                />
                              )}
                              {(item.attachmentType?.includes("pdf") ||
                                item.attachmentType?.includes("doc") ||
                                item.attachmentType?.includes("sheet") ||
                                item.attachmentType?.includes("text")) && (
                                  <a
                                    href={item.attachment}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: "#007bff", fontWeight: 600 }}
                                  >
                                    📎 View Attachment
                                  </a>
                                )}
                            </div>
                          )}
                        </div>
                        <span
                          style={{
                            fontSize: "12px",
                            color: "#888",
                            marginTop: "4px",
                            alignSelf: isSender ? "flex-end" : "flex-start",
                          }}
                        >
                          {getFormattedDateTime(item.createdAt)}
                        </span>
                      </li>
                    );
                  })}
                  <div ref={msgEndRef}></div>
                </ul>

                {/* Input */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    borderTop: "1px solid #ddd",
                    padding: "10px",
                    backgroundColor: "#fff",
                  }}
                >
                  {/* Attachment Preview */}
                  {attachment && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginBottom: "8px",
                        background: "#f1f1f1",
                        borderRadius: "10px",
                        padding: "8px 12px",
                      }}
                    >
                      {uploading ? (
                        <ClipLoader size={18} />
                      ) : attachment.type.startsWith("image/") ? (
                        <img
                          src={attachment.localUrl}
                          alt="preview"
                          style={{ width: "50px", height: "50px", borderRadius: "6px" }}
                        />
                      ) : attachment.type.startsWith("video/") ? (
                        <video
                          src={attachment.localUrl}
                          style={{ width: "60px", height: "40px", borderRadius: "6px" }}
                          muted
                        />
                      ) : (
                        <span>📎 {attachment.name}</span>
                      )}
                      <button
                        onClick={discardAttachment}
                        style={{
                          background: "none",
                          border: "none",
                          fontSize: "16px",
                          color: "#ff4d4f",
                          cursor: "pointer",
                        }}
                        title="Remove file"
                      >
                        ❌
                      </button>
                    </div>
                  )}

                  {/* Message Row */}
                  <div style={{ display: "flex", gap: "10px" }}>
                    <label htmlFor="file-upload" style={{ cursor: "pointer" }}>
                      📎
                    </label>
                    <input
                      id="file-upload"
                      type="file"
                      accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />

                    <input
                      type="text"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && (message.trim() || attachment?.uploaded))
                          sendMessage();
                      }}
                      placeholder={uploading ? "Uploading file..." : "Type your message..."}
                      disabled={uploading}
                      style={{
                        flex: 1,
                        border: "1px solid #ccc",
                        borderRadius: "20px",
                        padding: "8px 14px",
                        fontSize: "14px",
                        outline: "none",
                      }}
                    />
                    <button
                      type="button"
                      onClick={sendMessage}
                      disabled={uploading || (!message.trim() && !attachment?.uploaded)}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#007bff",
                        cursor: "pointer",
                        fontSize: "24px",
                      }}
                    >
                      {uploading ? <ClipLoader size={18} /> : <Send />}
                    </button>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          )}
        </>
      )}
    </>
  );
};

export default UpcomingUser;
